unable to read source [project]/momira.app/web/node_modules/src/html5-qrcode.ts